exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-729f84ea]{margin-right:30px}.checkbox>span[data-v-729f84ea]{position:absolute;z-index:2;margin-left:3px}", ""]);

// exports
